module.exports = __webpack_public_path__ + "img/question-mark.ca3e8588.svg";